export default __webpack_public_path__ + "static/media/13.a0678427.webp";